import React from "react";
import { Link } from "react-router-dom";
import { getVisaIdForDestination, useCardLimit } from "./homeData/homeConstants";
import { POPULARITY_STYLES } from "./homeData/popularityStyles";

const COMING_SOON_COUNTRIES = new Set([
  "New Zealand",
  "Australia",
]);

function DestCard({ dest, index }) {
  const isComingSoon = dest.fee === "Check Price" || COMING_SOON_COUNTRIES.has(dest.name);
  const visaId = isComingSoon ? "#" : getVisaIdForDestination(dest.name);
  const popStyle = POPULARITY_STYLES[dest.popularity] || {
    color: "#e5e7eb",
    bg: "rgba(255,255,255,.15)",
  };

  return (
      <Link
        to={isComingSoon ? "#" : `/visa/${visaId}`}
        className={`home-dcard${isComingSoon ? " home-dcard--coming-soon" : ""}`}
        aria-label={isComingSoon ? `${dest.name} — Coming Soon` : `View ${dest.name} visa options`}
        data-aos="fade-up"
        data-aos-delay={Math.min((index % 5) * 60, 240)}
        onClick={isComingSoon ? (e) => e.preventDefault() : undefined}
      >
      <div className="home-dcard__img-wrap">
        <img
          className="home-dcard__img"
          src={dest.img}
          alt={dest.name}
          loading="lazy"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
        <div className="home-dcard__fallback">G</div>
        {isComingSoon && <div className="home-dcard__coming-soon">Coming Soon...</div>}
      </div>

      <div className="home-dcard__scrim" />
      <div className="home-dcard__tag">{dest.tag}</div>

      <div className="home-dcard__body">
        <div className="home-dcard__name-row">
          <h3 className="home-dcard__name">{dest.name}</h3>
         
        </div>

        {dest.timing && <p className="home-dcard__timing">{dest.timing}</p>}

        {/* <div className="home-dcard__divider" /> */}

        <div className="home-dcard__footer">
          {isComingSoon ? (
            <span className="home-dcard__fee">
              <span className="home-dcard__fee-current">On the Way</span>
            </span>
          ) : (
            <span className="home-dcard__fee">
              <span className="home-dcard__best-label">Price</span>
              {dest.originalFee && <span className="home-dcard__fee-cut">{dest.originalFee}</span>}
              <span className="home-dcard__fee-current">{dest.fee}</span>
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

function DestNotFoundForm({ searchedTerm }) {
  const [form, setForm] = React.useState({
    name: "",
    phone: "",
    email: "",
    citizenship: "",
    destination: searchedTerm,
  });
  const [submitted, setSubmitted] = React.useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Enquiry Submitted:", form);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="home-dest-not-found home-dest-not-found--success">
        <div className="home-dest-not-found__icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <h3 className="home-dest-not-found__title">Request Submitted!</h3>
        <p className="home-dest-not-found__text">
          Thank you for your enquiry. Someone from our team will contact you soon regarding your visa for <strong>{searchedTerm}</strong>.
        </p>
      </div>
    );
  }

  return (
    <div className="home-dest-not-found">
      <div className="home-dest-not-found__icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <h3 className="home-dest-not-found__title">Destination Not Found?</h3>
      <p className="home-dest-not-found__text">We can still help! Fill the form below and we'll get back to you.</p>

      <form className="home-dest-not-found__form" onSubmit={handleSubmit}>
        <div className="home-dest-not-found__row">
          <div className="home-dest-not-found__field">
            <label className="home-dest-not-found__label">Your Name</label>
            <input name="name" className="home-dest-not-found__input" placeholder="Full Name" value={form.name} onChange={handleChange} required />
          </div>
          <div className="home-dest-not-found__field">
            <label className="home-dest-not-found__label">Phone Number</label>
            <input name="phone" type="tel" className="home-dest-not-found__input" placeholder="+91 98765 43210" value={form.phone} onChange={handleChange} required />
          </div>
        </div>
        <div className="home-dest-not-found__row">
          <div className="home-dest-not-found__field">
            <label className="home-dest-not-found__label">Email Address</label>
            <input name="email" type="email" className="home-dest-not-found__input" placeholder="you@example.com" value={form.email} onChange={handleChange} required />
          </div>
          <div className="home-dest-not-found__field">
            <label className="home-dest-not-found__label">Citizenship</label>
            <input name="citizenship" className="home-dest-not-found__input" placeholder="Your Citizenship" value={form.citizenship} onChange={handleChange} required />
          </div>
        </div>
        <div className="home-dest-not-found__field">
          <label className="home-dest-not-found__label">Destination Country</label>
          <input name="destination" className="home-dest-not-found__input" placeholder="Where do you want to go?" value={form.destination} onChange={handleChange} required />
        </div>
        <button type="submit" className="home-dest-not-found__submit">
          Submit Enquiry
        </button>
      </form>
    </div>
  );
}

function DestinationsLoading() {
  return (
    <div className="home-dest-grid" aria-label="Loading destinations">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="home-dcard" style={{ minHeight: 320, opacity: 0.65 }} />
      ))}
    </div>
  );
}

export default function Destinations({ search, filteredDestinations, isLoading = false }) {
  const limit = useCardLimit();
  const shown = filteredDestinations.slice(0, limit);
  const hasSearch = Boolean((search || "").trim());

  return (
    <section className="home-dest-section" id="destinations-section">
      <div className="home-dest-section__inner">
        {isLoading ? (
          <DestinationsLoading />
        ) : shown.length > 0 ? (
          <div className="home-dest-grid">
            {shown.map((destination, index) => (
              <DestCard key={destination.id} dest={destination} index={index} />
            ))}
          </div>
        ) : hasSearch ? (
          <DestNotFoundForm searchedTerm={search} />
        ) : (
          <div className="home-dest-not-found">
            <h3 className="home-dest-not-found__title">No destinations match your filters</h3>
            <p className="home-dest-not-found__text">Try adjusting your filter selection to see more results.</p>
          </div>
        )}
      </div>
    </section>
  );
}
